import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";

interface UnpinPatientResponse {
  patientIds: string[];
  userIds: number[];
}

interface unPinPatientParams {
  userId?: string;
  patientId?: string;
}

export const useUnpinPatient = (patientId: string) => {
  const queryClient = useQueryClient();

  return useApiMutation<UnpinPatientResponse, unPinPatientParams>({
    mutationOptions: {
      mutationKey:
        QueryKeys.Provider.AsyncMessageDashboard.UNPIN_PATIENT(patientId),
      mutationFn: (params) =>
        axiosInstance.post(
          "/new-api/async-messaging/pinned-patients/unpin",
          params,
        ),
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["provider", "async-message-dashboard", "pinned"],
        });
      },
    },
  });
};
